import {
  Avatar,
  Box,
  Drag1Icon,
  Edit1Icon,
  GKButton,
  Grid2,
  IconButton,
  PlusIcon,
  Show,
  Typography,
} from "components";
import { map } from "lodash";
import { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  setOpenTestimonialModal,
  setTestimonialDetails,
} from "store/slices/MyWebsiteSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import TestimonialsModal from "./TestimonialsModal";
import { WebsiteDetails } from "./types";

const TestimonialsForm = () => {
  const form = useFormContext<WebsiteDetails>();

  const dispatch = useAppDispatch();

  const openTestimonialModal = useAppSelector(
    (state) => state?.myWebsite?.openTestimonialModal,
  );
  const testimonialDetails = useAppSelector(
    (state) => state?.myWebsite?.testimonialDetails,
  );

  const [dragIndex, setDragIndex] = useState<number | null>(null);

  const { fields, move } = useFieldArray({
    control: form.control,
    name: "websiteSection.testimonials",
  });

  const handleOpenModal = () => {
    dispatch(setTestimonialDetails(null));
    dispatch(setOpenTestimonialModal(true));
  };

  const handleOpenTestimonialModal = () => {
    dispatch(setOpenTestimonialModal(false));
  };

  return (
    <>
      <Grid2 container size={12} spacing={"12px"}>
        <Grid2 size={12}>
          <GKButton
            variant="text"
            startIcon={<PlusIcon />}
            onClick={handleOpenModal}
          >
            Add New Testimonial
          </GKButton>
        </Grid2>

        {map(fields, (dataItem, index) => (
          <Grid2
            container
            key={dataItem?.id}
            size={12}
            p={"12px 8px"}
            border={"1px solid var(--neutral-100)"}
            borderRadius={2.5}
            display={"flex"}
            alignItems={"center"}
            draggable
            onDragStart={() => setDragIndex(index)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => {
              if (dragIndex === null || dragIndex === index) return;
              move(dragIndex, index);
              setDragIndex(null);
            }}
            onDragEnd={() => setDragIndex(null)}
            onDragEnter={(e) => e.preventDefault()}
            onDragLeave={(e) => e.preventDefault()}
            sx={{
              borderBottom: "1px solid var(--neutral-100)",
              "&::before": { display: "none" },
              opacity: dragIndex === index ? 0.5 : 1,
              cursor: "grab",
            }}
          >
            <Grid2 size={10} display={"flex"} alignItems={"center"} gap={2}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton sx={{ cursor: "move" }}>
                  <Drag1Icon color={"var(--neutral-500)"} />
                </IconButton>
                <Avatar
                  alt=""
                  src={dataItem?.clientsImage || "/Logos/errorImg.svg"}
                />
              </Box>
              <Typography
                fontSize={12}
                fontWeight={500}
                color="var(--grey-900)"
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordBreak: "break-word",
                }}
              >
                {dataItem?.clientsReview}
              </Typography>
            </Grid2>
            <Grid2 size={2} textAlign={"end"}>
              <IconButton
                onClick={() => {
                  dispatch(setTestimonialDetails(dataItem));
                  dispatch(setOpenTestimonialModal(true));
                }}
              >
                <Edit1Icon width={16} height={16} />
              </IconButton>
            </Grid2>
          </Grid2>
        ))}
      </Grid2>

      <Show.When isTrue={openTestimonialModal}>
        <TestimonialsModal
          open={openTestimonialModal}
          setOpen={handleOpenTestimonialModal}
          testimonialDetails={testimonialDetails}
        />
      </Show.When>
    </>
  );
};

export default TestimonialsForm;
